
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    locale: { type: String },
    empty: { type: String, default: "-" },
  },
});
